export const IPL_TEAMS = [
  {
    id: "CSK",
    name: "Chennai Super Kings",
    short: "CSK",
    color: "#fdb913",
    slogan: "Whistle Podu! 💛",
    cta: "Whistle & snack like a true CSK fan 💛",
    logo: "https://wallpaperaccess.com/full/9050356.png",
  },
  {
    id: "MI",
    name: "Mumbai Indians",
    short: "MI",
    color: "#004ba0",
    slogan: "Duniya Hila Denge 💙",
    cta: "Power up your match with MI snacks 💙",
    logo: "https://tse4.mm.bing.net/th/id/OIP.y3G5UvFg-xFx7-F_78bLgwHaFq?pid=Api&P=0&h=180",
  },
  {
    id: "RCB",
    name: "Royal Challengers Bengaluru",
    short: "RCB",
    color: "#d71920",
    slogan: "Ee Sala Cup Namde ❤️",
    cta: "RCB fans, snack like champions ❤️",
    logo: "https://tse2.mm.bing.net/th/id/OIP.aFmEcv_k3A7Ts6897Hwt9gAAAA?pid=Api&P=0&h=180",
  },
  {
    id: "KKR",
    name: "Kolkata Knight Riders",
    short: "KKR",
    color: "#3a225d",
    slogan: "Korbo Lorbo Jeetbo 💜",
    cta: "Knight riders need knight snacks 💜",
    logo: "https://tse2.mm.bing.net/th/id/OIP.xWhOOo_sXujMzLTtsk-JqgHaEZ?pid=Api&P=0&h=180",
  },
  {
    id: "DC",
    name: "Delhi Capitals",
    short: "DC",
    color: "#17479e",
    slogan: "Roar Macha 🔵",
    cta: "Delhi fans, fuel the roar 🔵",
    logo: "https://tse4.mm.bing.net/th/id/OIP.aTOkfqzFVDxDHGH5YEL1SAAAAA?pid=Api&P=0&h=180",
  },
  {
    id: "RR",
    name: "Rajasthan Royals",
    short: "RR",
    color: "#ea1a85",
    slogan: "Halla Bol 💗",
    cta: "Royal snacks for royal fans 💗",
    logo: "https://tse2.mm.bing.net/th/id/OIP.P2_f0vhOz8WXASjfSadc_QHaEK?pid=Api&P=0&h=180",
  },
  {
    id: "SRH",
    name: "Sunrisers Hyderabad",
    short: "SRH",
    color: "#ff822a",
    slogan: "Orange Army Rising 🧡",
    cta: "Snack like the Orange Army 🧡",
    logo: "https://tse2.mm.bing.net/th/id/OIP.1iZ6B40xEpZCiFUT9p0iWAHaEo?pid=Api&P=0&h=180",
  },
  {
    id: "PBKS",
    name: "Punjab Kings",
    short: "PBKS",
    color: "#ed1b24",
    slogan: "Sadda Punjab ❤️",
    cta: "Punjab style snacks, full power ❤️",
    logo: "https://tse1.mm.bing.net/th/id/OIP.4QitsaSVnHLfptC9r-t5swHaEK?pid=Api&P=0&h=180",
  },
  {
    id: "GT",
    name: "Gujarat Titans",
    short: "GT",
    color: "#2b2f3a",
    slogan: "Aava De! 💙",
    cta: "Titans need titan-sized snacks 💙",
    logo: "https://tse3.mm.bing.net/th/id/OIP.aJmjscBMLM0b1wNsK_dMrAHaFj?pid=Api&P=0&h=180",
  },
  {
    id: "LSG",
    name: "Lucknow Super Giants",
    short: "LSG",
    color: "#00aaff",
    slogan: "Ab Apni Baari 💙",
    cta: "Lucknow fans, it’s snack time 💙",
    logo: "https://tse3.mm.bing.net/th/id/OIP.hHSSZR27mzirtusLrPN_eQHaHa?pid=Api&P=0&h=180",
  },
];
